import { useDispatch } from 'react-redux';
import { useErrorHandlingSlice } from 'app/error/slice';
import Cookies from 'js-cookie';

export const useAccessToken = () => {
  const dispatch = useDispatch();
  const { actions } = useErrorHandlingSlice();
  const accessToken = Cookies.get('access_token');

  if (!accessToken) {
    dispatch(
      actions.dispatchToast({
        errorTxt: 'No access token found',
        show: true,
        errorType: 'error',
      }),
    );
  }

  return accessToken;
};
